/* eslint-disable no-nested-ternary */

/* eslint-disable react/no-danger */

/* eslint-disable react/jsx-indent */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';
import { cleanExternalLinks } from '../../lib/utils';

import Image from '../partials/Image';
import Link from '../partials/Link';
import Poster from '../partials/Poster';

import styles from '../../../styles/cards/prize.module.scss';

import trophy from '../../../img/trophy.png';

const propTypes = {
    item: AppPropTypes.listItem,
    award: AppPropTypes.listItem,
    vertical: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    item: null,
    award: null,
    vertical: false,
    className: null,
};

const PrizeCard = ({ item, award, vertical, className }) => {
    const { title = null, description = null, winners = null, sponsors = null } = item || null;
    const winner = winners !== null && winners.length > 0 ? winners[0] : null;
    const sponsor = sponsors !== null && sponsors.length > 0 ? sponsors[0] : null;
    const {
        image: sponsorImage = null,
        url: sponsorUrl = null,
        name: sponsorName = null,
    } = sponsor || {};
    const { label: winnerLabel = null, films = null } = winner || {};
    const film = winner !== null && films.length > 0 ? films[0] : null;

    const {
        title: filmTitle = null,
        directors = null,
        countries = null,
        image = null,
        url = null,
        poster = null,
    } = film || {};

    const { colors = null } = poster || image || {};
    const [fromColor = null, toColor = null] = colors || [];

    const { title: awardTitle = null } = award || {};

    const visual =
        url !== null ? (
            <Link
                className={classNames(styles.visual, styles.visualLink)}
                href={url}
                style={
                    fromColor !== null && toColor !== null
                        ? {
                              backgroundImage: `linear-gradient(to bottom, ${fromColor} 30%, ${toColor} 100%)`,
                          }
                        : null
                }
            >
                <span className={styles.posterContainer}>
                    <Poster className={styles.poster} item={film} />
                </span>
            </Link>
        ) : (
            <div
                className={styles.visual}
                style={
                    fromColor !== null && toColor !== null
                        ? {
                              backgroundImage: `linear-gradient(to bottom, ${fromColor} 30%, ${toColor} 100%)`,
                          }
                        : null
                }
            >
                <span className={styles.posterContainer}>
                    <Poster item={film} className={styles.poster} />
                </span>
            </div>
        );
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.vertical]: vertical,
                },
            ])}
        >
            <div className={styles.content}>
                <div className={styles.prizeInfo}>
                    <div className={styles.logos}>
                        <Image imageClassName={styles.trophy} media={{ url: trophy }} />
                        {!vertical && sponsorImage !== null && sponsorUrl !== null ? (
                            <Link href={sponsorUrl} external>
                                <Image
                                    imageClassName={styles.sponsorLogo}
                                    media={sponsorImage}
                                    alt={sponsorName}
                                />
                            </Link>
                        ) : null}
                        {!vertical && sponsorImage !== null && sponsorUrl === null ? (
                            <Image
                                imageClassName={styles.sponsorLogo}
                                media={sponsorImage}
                                alt={sponsorName}
                            />
                        ) : null}
                    </div>

                    {awardTitle !== null && vertical ? (
                        <div className={styles.info}>{awardTitle}</div>
                    ) : null}
                    <h3 className={styles.prizeTitle}>{title}</h3>
                    <div
                        className={styles.info}
                        dangerouslySetInnerHTML={{
                            __html: cleanExternalLinks(description),
                        }}
                    />
                </div>
                <div
                    className={classNames([
                        styles.winnerInfo,

                        {
                            [styles.withLabel]: winnerLabel !== null,
                        },
                    ])}
                >
                    {winnerLabel ? (
                        <h2 className={classNames([styles.title, styles.winnerLabel])}>
                            {winnerLabel}
                        </h2>
                    ) : null}
                    <div className={styles.filmInfo}>
                        {directors !== null ? (
                            <h3 className={styles.subtitle}>
                                {directors.map(
                                    ({ name: directorName = null, firstName = null }, idx) => (
                                        // eslint-disable-next-line react/jsx-indent
                                        <span
                                            key={`director-${firstName}-${idx + 1}`}
                                            className={styles.inlineList}
                                        >
                                            {directorName}
                                        </span>
                                    ),
                                )}
                            </h3>
                        ) : null}
                        {url !== null ? (
                            <Link href={url} className={styles.link}>
                                <h2 className={styles.title}>{filmTitle}</h2>
                            </Link>
                        ) : (
                            <h2 className={styles.title}>{filmTitle}</h2>
                        )}
                    </div>
                    {countries !== null ? (
                        <div className={styles.countries}>
                            {countries.map(({ label = null }, idx) => (
                                <span
                                    key={`${label}-${idx + 1}`}
                                    className={classNames([styles.country, styles.inlineList])}
                                >
                                    {label}
                                </span>
                            ))}
                        </div>
                    ) : null}
                </div>
            </div>
            {visual}
        </div>
    );
};
PrizeCard.propTypes = propTypes;
PrizeCard.defaultProps = defaultProps;

export default PrizeCard;
